import * as yup from 'yup';

export default yup.object().shape({
  email: yup.string().required('이메일 주소(아이디)를 입력하세요.'),
});
